"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSvdVersion = exports.SET_SVD_VERSION = exports.PENDING_SVD_VERSION = exports.SVD_VERSION = void 0;
exports.SVD_VERSION = '[SVD Version]';
exports.PENDING_SVD_VERSION = 'svd-loading';
exports.SET_SVD_VERSION = `${exports.SVD_VERSION} SET`;
const setSvdVersion = ({ version = exports.PENDING_SVD_VERSION }) => ({
    type: exports.SET_SVD_VERSION,
    payload: version,
    meta: { feature: exports.SVD_VERSION },
});
exports.setSvdVersion = setSvdVersion;
//# sourceMappingURL=svdVersion.js.map